import Typography from "../../../designComponents/Typography";
import Checkbox from "../../../designComponents/Checkbox";
import { Form, Formik } from "formik";
import { AddPropertyProps } from ".";
import Button from "../../../designComponents/Button";

const Amenities = ({
  initialValues,
  onUpdate,
  gotoPrevious,
  errorMessage,
  loading,
}: AddPropertyProps) => {
  const amenities = [
    "Cleaning",
    "Electricity",
    "Carpenting",
    "Decoration",
    "Guttering",
    "Gardening",
    "Plumbing",
    "Gas",
    "Appliance Service",
    "Pest Control",
    "Roofing",
    "Builder",
  ];

  return (
    <div>
      <Typography style={{ marginBottom: "30px" }} size="h3">
        Step 3: Amenities
      </Typography>

      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          onUpdate(values);
        }}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
              {amenities.map((amenity, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "calc(60% - 200px)",
                  }}
                >
                  <Checkbox
                    isChecked={values?.features?.includes(amenity)}
                    onChange={(e: any) => {
                      const newFeatures = [...(values.features || [])];
                      if (e.target.checked) {
                        newFeatures.push(amenity);
                      } else {
                        const indexToRemove = newFeatures.indexOf(amenity);
                        if (indexToRemove > -1) {
                          newFeatures.splice(indexToRemove, 1);
                        }
                      }
                      setFieldValue("features", newFeatures);
                    }}
                  >
                    <Typography>{amenity}</Typography>
                  </Checkbox>
                </div>
              ))}
            </div>
            {errorMessage && (
              <Typography style={{ color: "red" }}>{errorMessage}</Typography>
            )}
            <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <Button
                type="button"
                radius="normal"
                onClick={gotoPrevious}
                isDisabled={loading}
              >
                Previous
              </Button>
              <Button type="submit" radius="normal" isLoading={loading}>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Amenities;
